import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/design-tokens.css';
import './styles/utilities.css';
import './styles/components.css';
import './styles/app.css';
import './styles/dark-mode.css';
import App from './App';

// Block iOS Safari pinch-zoom to prevent visual viewport divergence
// (header cut-off bug). Trade-off: kills all multi-finger gestures on the page.
// Acceptable per product brief: working users on the floor, accidental zoom is
// more harmful than helpful. Text legibility is addressed via the --m-text-*
// tokens (body 15px, meta 14px, button 15/600).
//
// Why this beats viewport meta + touch-action alone: even with
// `user-scalable=no, maximum-scale=1` and `touch-action: manipulation`,
// iOS Safari still allows pinch-zoom in some contexts and the visual viewport
// can diverge from the layout viewport — once that happens, the sticky
// header visually escapes the visible area until the page is reloaded.
// `passive: false` is critical: without it, modern browsers ignore
// preventDefault on touch / gesture events.
if (typeof window !== 'undefined') {
  document.addEventListener('gesturestart',  e => e.preventDefault(), { passive: false });
  document.addEventListener('gesturechange', e => e.preventDefault(), { passive: false });
  document.addEventListener('gestureend',    e => e.preventDefault(), { passive: false });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
